
import { useNavigate, useParams } from "react-router-dom";

import { Grid } from "@mui/material";
import { DisenioGranja } from "../../layout";
import { TarjetasOpciones } from "../../components";
import { useGranjaXID } from "../../../hooks";





export const OpcionesGranja = () => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { granjaXIDQuery } = useGranjaXID(`${id}`);
    const granja = granjaXIDQuery?.data;
    

    const handleNavegar = (url) => {
        navigate(`/admin/granja/${id}/${url}`)
    }


    const data = [
        {key:1, titulo:'Editar Granja', function: handleNavegar, url:'edit', icono:'setting'},
        {key:2, titulo:`Bodegas ${granja?.canBodegas ?? 0}`, function: handleNavegar, url:`bodegas`, icono:'granja'},
        {key:3, titulo:`Galpones ${granja?.canGalpones ?? 0}`, function: handleNavegar, url:`galpones`, icono:'galpon'},
        {key:4, titulo:'Lotes', function: handleNavegar, url:`lotes`, icono:'lote'},
    ];



    return (

        <DisenioGranja titulo="Opciones de Granja">

            <Grid container spacing={3} sx={{mt:1}}>
                {data.map( item => (
                    <Grid key={item.key} item xs={6} sm={4} md={3}>
                        <TarjetasOpciones 
                            onClickHandler={item.function} 
                            url={item.url} 
                            icono={item.icono} 
                            titulo={item.titulo} 
                        />
                    </Grid>
                ))}
            </Grid>

        </DisenioGranja>

    )
}
